import flowDesignerReducer from './flow.reducer';

export default flowDesignerReducer;
